import script from "./RedPacketTips.vue?vue&type=script&setup=true&lang=js"
export * from "./RedPacketTips.vue?vue&type=script&setup=true&lang=js"

import "./RedPacketTips.vue?vue&type=style&index=0&id=237754d5&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\虎鲸\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-237754d5"]])

export default __exports__